<template>
  <div>
    <UserAccount :selectedStatuses="statuses"></UserAccount>
  </div>
</template>

<script>
import { defineAsyncComponent } from "vue";
const UserAccount = defineAsyncComponent(() =>
  import("@/components/addUser/UserAccount")
);
export default {
  components: {
    UserAccount,
  },
  data() {
    return {
      statuses: "ACTIVE",
    };
  },
};
</script>
